<template>
  <div id="login-page">
    <div class="title">
      <div class="logo">
        <img src="../assets/logo.png" alt />
      </div>
      <h2>会员IP授权系统</h2>
      <small style="cursor:pointer" @click="authorRegister">
        注册为创作者
        <i class="el-icon-caret-right"></i>
      </small>
    </div>
    <div class="login-main">
      <div class="inputs">
        <el-input v-model="username" placeholder="请输入用户名"></el-input>
        <el-input v-model="password" placeholder="请输入密码" show-password @keyup.enter.native="toLogin"></el-input>
        <div class="com-btn" @click="toLogin">立即登录</div>
      </div>
    </div>
    <div class="copy-right">
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备18039042号-1</a>
    </div>
  </div>
</template>

<script>
import API from "../lib/API";

export default {
    name: "Login",
    data() {
        return {
            password: "",
            username: ""
        };
    },
    methods: {
        authorRegister() {
					this.$router.push('/producerRegister');
				},
        toLogin() {
            if (!this.username || !this.password) {
                this.$message.error("用户名和密码必须填写完整哦");
                return;
            }

            new API(this).POST({
                url: "/user/loginByUsername",
                params: {
                    password: this.password,
                    username: this.username
                },
                cb: res => {
                    localStorage.setItem("shopName", res.shopName);
                    localStorage.setItem("authorName", res.authorName);
                    localStorage.setItem("token", res.accesstoken);
                    localStorage.setItem("isAdmin", res.isAdmin);
                    localStorage.setItem("roleId", res.roleId)
                    localStorage.setItem("shopId", res.shopId)
                    localStorage.setItem("authorId", res.authorId)
                    localStorage.setItem("authorType", res.authorType)
                    // 阿里实名认证状态
                    localStorage.setItem("aliVerityStatus", res.aliVerityStatus)
										// 审核状态
                    localStorage.setItem("checkStatus", res.checkStatus)
                    if (res.roleId == 4) {
											// 品牌商跳转到ip浏览
											this.$router.push({ name: "IpList" });
                    } else if(res.roleId == 5) {
                      if (res.checkStatus === 1) {
                        this.$router.push({ name: "MyIpManage" });
                      } else {
                        this.$router.push({ name: "SupplyInfo" });
                      }
                    } else {
											this.$router.push({ name: "OrderList" });
										}
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#login-page {
  padding: 10px;
  height: 100%;
  background: #1a3b35;

  .title {
    width: 400px;
    margin: 100px auto 20px;
    color: #fff;
    position: relative;
    .logo {
      img {
        margin: 35px auto;
        width: 150px;
        display: block;
      }
    }
    h2 {
      font-size: 16px;
      font-weight: bold;
      margin-top: 15px;
      opacity: 0.8;
    }
    small {
      position: absolute;
      right: 0;
      bottom: 2px;
      color: #ff0;
    }
  }

  .login-main {
    background: #fff;
    width: 400px;
    margin: 20px auto 20px;
    border-radius: 6px;

    padding: 30px 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .inputs {
      padding: 0 30px;
      .el-input {
        margin-bottom: 20px;
        input {
          border-color: #1a3b35;
        }
      }
    }

    .com-btn {
      display: block;
      text-align: center;
      color: #fff;
      background: #1a3b35;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 6px;
      transition: all 0.4s;
      cursor: pointer;
      &:hover {
        background: #111;
        color: #ff0;
      }
    }
  }
  .copy-right {
    text-align: center;
    color: #fff;
    opacity: 0.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue